module.exports = __webpack_public_path__ + "img/domestic-2015-encyclopedia.11b40d98.jpg";